import { TypographyProps, Typography } from '@material-ui/core';
import React from 'react';

interface INewlineTextProps extends Omit<TypographyProps, 'children'> {
  text: string;
}

export default function NewlineText({ text, ...props }: INewlineTextProps) {
  const newText = text
    .split('\n')
    .map((str) => <Typography {...props}>{str}</Typography>);
  return <>{newText}</>;
}
